import React, { useState } from 'react'

import { makeStyles, createStyles, Box, Tabs, Tab, Divider, useTheme, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useImageTranslation } from 'src/hooks'
// import { useLocation } from 'react-router'
import { useRouteMatch } from 'react-router-dom'
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      boxShadow: `0 0.5px 0 0 ${theme.palette.grey[100]}`,
      marginBottom: theme.spacing(1.5),
      '& .MuiTabs-indicator': {
        backgroundColor: '#F2512D',
      },
    },
    container: {
      marginLeft: theme.spacing(-1.5),
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'space-around',
      },
    },
    indicator: {
      '&:before': {
        width: `${theme.spacing(8)}px !important`,
      },
    },
    logo: {
      display: 'block',
      width: theme.spacing(12),
    },
    wrapped: {
      fontWeight: 600,
      // minWidth: '60%',
      [theme.breakpoints.down('xs')]: {
        width: 130,
      },
    },
  }),
)
const types = [
  {
    value: 'phone',
    label: 'form.mobile',
  },
  {
    value: 'email',
    label: 'form.email',
  },
]

const AuthForm = (props) => {
  // const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const activeTab = props?.activeTab || ''
  const [value, setValue] = useState(activeTab === 'email' ? 1 : 0)
  const [tImage] = useImageTranslation()
  let isOrder =
    useRouteMatch(`/${i18n.language}/add-order/signin`) ||
    useRouteMatch(`/${i18n.language}/add-order/signup`) ||
    useRouteMatch(`/${i18n.language}/add-order/forgot-password`)
  console.log(isOrder)
  const handleChange = (event, newValue) => {
    setValue(newValue)
    props.onChange?.(types[newValue]?.value)
  }
  return (
    <>
      <Box mt={isOrder ? 0 : 1} className={classes.root}>
        {isMobile && !isOrder ? <Divider /> : ''}
        {/* {isMobile || isOrder ? (
          ''
        ) : (
          <Box fontSize={26} fontWeight={600} mb={3} mt={4} lineHeight="150%">
            {location.pathname.includes('/signup')
              ? t('common.signUp')
              : location.pathname.includes('/signin')
              ? t('tips.welcome_back')
              : ''}
          </Box>
        )} */}

        <Tabs
          classes={{
            flexContainer: classes.container,
            // indicator: classes.indicator,
          }}
          indicatorColor="secondary"
          value={value}
          onChange={handleChange}
          // aria-label="verification type tabs"
        >
          {types.map((type) => (
            <Tab
              key={type.value}
              label={`${t(type.label)}${i18n.language === 'en' ? ' ' : ''}${props?.authType || ''}`}
              classes={{
                root: classes.tabroot,
                wrapper: classes.wrapped,
              }}
            />
          ))}
        </Tabs>
      </Box>
      {isMobile ? (
        <Box my={5} justifyContent="center" display={props?.hideLogo ? 'none' : 'flex'}>
          <img className={classes.logo} src={tImage('logo', 'png')} />
        </Box>
      ) : (
        ''
      )}
    </>
  )
}

export default AuthForm
